// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__J8rBH","text_danger":"TablaProducto_text_danger__pw-9c","text_success":"TablaProducto_text_success__JV71K"};